import React from 'react'
import {
  presenceErrorClass,
} from 'servos/formValidations'
import Card from '../../../commons/Card'
import ErrorMessageCard from '../../../commons/ErrorMessageCard'

class Identity extends React.Component {
  componentDidMount() {
    if (this.props.identityVerification) {
      document.querySelector('#identityVerification').checked = true
    }
  }

  componentWillUpdate(nextProps) {
    if (nextProps.identityVerification) {
      document.querySelector('#identityVerification').checked = true
    } else {
      document.querySelector('#identityVerification').checked = false
    }
  }

  render() {
    const {
      displayErrorMessage,
      handleIdentityVerification,
    } = this.props

    // TODO We need to display this error message when we have Equifax in place
    return (
      <Card
        iconName='checklist'
        title='Identity verification and credit check'
      >
        { displayErrorMessage &&
        <div className='card-body'>
          <ErrorMessageCard title='We could not verify your identity' >
            <p>There was a problem with the details you provided. Please review the following information before trying to verify again:</p>
            <ul className="pl-3">
              <li>Name</li>
              <li>Date of birth</li>
              <li>Residential address</li>
            </ul>
          </ErrorMessageCard>
        </div>
        }
        <div className="card-footer">
          <div className="custom-control custom-checkbox">
            <input
              id="identityVerification"
              className="custom-control-input"
              type="checkbox"
              onChange={handleIdentityVerification}
            />
            <label className="custom-control-label" htmlFor="identityVerification">
              <span>I agree for Yard to verify the personal details I provided against the personal information held by a credit reporting body in my credit file, and I consent to have my identity information verified with the Identification Document Issuer or Official Record Holder via third party systems.</span>
            </label>
          </div>
        </div>
      </Card>
    )
  }
}

export default Identity;
